class $9cf8872db4863d07$export$2e2bcd8739ae039 {
    constructor(projectsData){
        // Projects with "disabled": true are left out completely
        this._projectsData = Object.fromEntries(Object.entries(projectsData).filter(([, project])=>project.disabled !== true));
        this._allTags = this.getAllTags();
    }
    getAllTags() {
        const tags = new Set();
        for (const project of Object.values(this._projectsData)){
            if (project.tags) for (const tag of project.tags)tags.add(tag);
            else console.log(project.name, "has no tags");
        }
        return tags;
    }
    displayProjects(container) {
        for (const project of Object.values(this._projectsData)){
            const projectHtml = this.getProjectHtml(project);
            container.appendChild(projectHtml);
        }
    }
    getProjectHtml(projectData) {
        const card = this.createHtmlElement("div", "", null, "", [
            "project-card"
        ]);
        if (projectData.cover) {
            const img = this.createHtmlElement("img", "", card, "", [
                "project-img"
            ]);
            img.src = projectData.cover;
            img.alt = projectData.name;
        }
        const content = this.createHtmlElement("div", "", card, "", [
            "project-content"
        ]);
        const textArea = this.createHtmlElement("div", "", content, "", [
            "project-text-area"
        ]);
        const title = this.createHtmlElement("h3", projectData.name, textArea, "", []);
        const tags = this.createHtmlElement("p", projectData.tags.join(", "), textArea, "", []);
        const button = this.createHtmlElement("button", "View Project", content, "", []);
        button.addEventListener("click", ()=>{
            window.location.href = projectData.page;
        });
        return card;
    }
    createHtmlElement(type, text, parent, id, classes) {
        const element = document.createElement(type);
        if (text != "") element.textContent = text;
        if (parent != null && parent != undefined) parent.appendChild(element);
        if (id != "") element.id = id;
        if (classes && classes.length > 0) element.classList.add(classes);
        return element;
    }
}


// All projects shown on the home page, in display order.
// - page:     the project's folder in src/projects/
// - cover:    must use `new URL("<path>", import.meta.url)` so Parcel bundles the image
// - disabled: set to true to hide the project from the home page
var $f5ab854cbedd5190$exports = {};
$f5ab854cbedd5190$exports = import.meta.resolve("lD5AF");


var $811db622a4682f77$exports = {};
$811db622a4682f77$exports = import.meta.resolve("cynCe");


var $4bb361e19d565898$exports = {};
$4bb361e19d565898$exports = import.meta.resolve("9A71o");


var $ebb1880483381a0e$exports = {};
$ebb1880483381a0e$exports = import.meta.resolve("jZ92Z");


var $4afe03420ca09ff6$exports = {};
$4afe03420ca09ff6$exports = import.meta.resolve("ffzTq");


var $e3865e9c8d33c444$exports = {};
$e3865e9c8d33c444$exports = import.meta.resolve("hSC9O");


var $67fe417746f82e76$exports = {};
$67fe417746f82e76$exports = import.meta.resolve("imxPd");


var $f7da135987bc301b$exports = {};
$f7da135987bc301b$exports = import.meta.resolve("6F3rz");


var $6261f8cd4a6f0792$export$2e2bcd8739ae039 = {
    a_fantasy_story: {
        name: "A Fantasy Story",
        tags: [
            "Unity",
            "Co-op",
            "Game",
            "C#"
        ],
        page: "projects/a_fantasy_story/index.html",
        cover: new URL($f5ab854cbedd5190$exports)
    },
    another_door: {
        name: "Another Door",
        tags: [
            "JavaScript",
            "Game"
        ],
        page: "projects/another_door/index.html",
        cover: new URL($811db622a4682f77$exports)
    },
    endless_swarm: {
        name: "Endless Swarm",
        tags: [
            "JavaScript",
            "WebGL",
            "Pixi.js",
            "Game"
        ],
        page: "projects/endless_swarm/index.html",
        cover: new URL($4bb361e19d565898$exports)
    },
    cappuccino_hut: {
        name: "Cappuccino Hut",
        tags: [
            "Unity",
            "VR",
            "Game",
            "C#"
        ],
        page: "projects/cappuccino_hut/index.html",
        cover: new URL($ebb1880483381a0e$exports)
    },
    last_cat_standing: {
        name: "Last Cat Standing",
        disabled: true,
        tags: [
            "Unity",
            "Game",
            "Blender",
            "C#"
        ],
        page: "projects/last_cat_standing/index.html",
        cover: new URL($4afe03420ca09ff6$exports)
    },
    led_lamp: {
        name: "LED-lampa",
        tags: [
            "Python",
            "MicroPython",
            "Blender",
            "3D Printing",
            "Neopixel"
        ],
        page: "projects/led_lamp/index.html",
        cover: new URL($e3865e9c8d33c444$exports)
    },
    minetrim: {
        name: "Minetrim",
        tags: [
            "JavaScript",
            "Website",
            "Three.js"
        ],
        page: "projects/minetrim/index.html",
        cover: new URL($67fe417746f82e76$exports)
    },
    apartment_display: {
        name: "Apartment Display",
        tags: [
            "Python",
            "Website",
            "Scraper",
            "JavaScript",
            "Leaflet.js",
            "BeautifulSoup"
        ],
        page: "projects/apartment_display/index.html",
        cover: new URL($f7da135987bc301b$exports)
    }
};


const $4fafbfd915416676$var$projectsConnect = new (0, $9cf8872db4863d07$export$2e2bcd8739ae039)((0, $6261f8cd4a6f0792$export$2e2bcd8739ae039));
const $4fafbfd915416676$var$projectsArea = document.getElementById("projects-area");
$4fafbfd915416676$var$projectsConnect.displayProjects($4fafbfd915416676$var$projectsArea);


//# sourceMappingURL=portfolio.e6888366.js.map
